/**
 * Copyright © Vaimo Group. All rights reserved.
 * See LICENSE_VAIMO.txt for license details.
 */

import customerData from 'Magento_Customer/js/customer-data';

const licenseRegexp = /<!--[\s\S]*?-->/;

const MESSAGE_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
    NOTICE: 'notice',
    WARNING: 'warning'
};

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
function isObject (item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
function mergeDeep (target, ...sources) {
    if (!sources.length) return target;

    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) { // eslint-disable-line max-depth
                if (!target[key]) Object.assign(target, { [key]: {} }); // eslint-disable-line max-depth
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

function removeLicense (content) {
    return content.replace(licenseRegexp, function (match) {
        return ~match.indexOf('/**') ? '' : match;
    });
}

function addMessage ({ text, type }) {
    const customerMessages = customerData.get('messages')() || {};
    const messages = customerMessages.messages || [];

    messages.push({
        text: text,
        type: type
    });

    customerMessages.messages = messages;
    customerData.set('messages', customerMessages);
}

export default {
    isObject,
    mergeDeep,
    removeLicense,
    addMessage,
    MESSAGE_TYPES
};
